import React from "react";
import Sidebar from "../../../components/Sidebar";
import ReviewListsComponent from "../../../components/reviewLists/ReviewListsComponent";

function ReviewList() {
  return (
    <Sidebar>
      <ReviewListsComponent />
    </Sidebar>
  );
}

export default ReviewList;
